export enum EnumSendOccasionType {
    CalendarEvent = 1,
    CalenderOrganizationEvent = 2,
    CustomField = 3,
  }
  